import React, { PureComponent } from 'react'
import { Segment, Container } from 'semantic-ui-react'
import { getApi } from '../../services/api-catalog'
import { showApiKey, isAuthenticated } from '../../services/self'

export default class ApiDetailsPage extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
        isAuthenticated: false,
        apiId: props.match.params.apiId,
        apiKey: ''
    }
  }

  componentDidMount() {
    if(isAuthenticated()) {
        showApiKey().then(apiKey => {
          this.setState({ apiKey })
          getApi(this.state.apiId)
            .then(api => {
              var ui = window.SwaggerUIBundle({
                  dom_id: '#swagger-ui-container',
                  url: 'http://petstore.swagger.io/v2/swagger.json',
                  spec: api.swagger
              })

              if(this.state.apiKey != '') {
                ui.authActions.authorize({
                    api_key: {
                        name: "api_key",
                        schema: {type: "apiKey", in: "header", name: "x-api-key", description: ""},
                        value: this.state.apiKey}});
              }
            })
        })
    } else {
        getApi(this.state.apiId)
          .then(api => {
            var ui = window.SwaggerUIBundle({
                dom_id: '#swagger-ui-container',
                url: 'http://petstore.swagger.io/v2/swagger.json',
                spec: api.swagger
            })

            if(this.state.apiKey != '') {
              ui.authActions.authorize({
                  api_key: {
                      name: "api_key",
                      schema: {type: "apiKey", in: "header", name: "x-api-key", description: ""},
                      value: 'abcd'}});
            }
          })
    }
  }

  render() {
    return (<div>
      <Container>
      <Segment className="block">
      <section className="swagger-section" style={{overflow: 'auto'}}>
        <div className="swagger-ui-wrap" id="swagger-ui-container"></div>
      </section>
      </Segment>
      </Container>
    </div>)
  }
}



/** WEBPACK FOOTER **
 ** ./src/pages/ApiDetails/index.js
 **/